/** Longest a step waits for a repaint before carrying on regardless. */
export const REPAINT_WAIT_MAX_MS = 100;

/**
 * Resolve once the browser has painted, so a line from `ehq.log()` shows up
 * live while the step keeps running. Two animation frames: the first runs
 * change detection, the second is the repaint.
 *
 * Browsers do not fire animation frames in a hidden tab, so waiting on them
 * alone stalled every logging step while the user was on another tab. A hidden
 * page has nothing to paint, so it resolves at once, and a timeout covers a
 * tab that is hidden mid-wait.
 */
export function waitForRepaint(): Promise<true> {
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
    return Promise.resolve(true);
  }
  return new Promise(resolve => {
    const done = () => {
      clearTimeout(timer);
      resolve(true);
    };
    const timer = setTimeout(done, REPAINT_WAIT_MAX_MS);
    requestAnimationFrame(() => requestAnimationFrame(done));
  });
}
